import request from '@/utils/request'

// 获取用户列表
export function getUserList(data) {
  return request({
    url: '/user/getUserListPage',
    method: 'post',
    data
  })
}

// 创建用户
export function createUser(data) {
  return request({
    url: '/user',
    method: 'post',
    data
  })
}

// 更新用户
export function updateUser(data) {
  return request({
    url: `/user/editUser`,
    method: 'post',
    data
  })
}

// 删除用户
export function deleteUser(params) {
  return request({
    url: `/user/deleteUser`,
    method: 'delete',
    params
  })
}

// 切换用户状态
export function toggleUserStatus(id) {
  return request({
    url: `/user/${id}/status`,
    method: 'put'
  })
}

// 获取用户详情
export function getUserDetail() {
  return request({
    url: `/user/getUserDetail`,
    method: 'get'
  })
}

// 修改密码
export function changePassword(data) {
  return request({
    url: '/user/editUserPassword',
    method: 'post',
    data
  })
}

// 重置密码
export function resetPassword(id) {
  return request({
    url: `/user/${id}/password/reset`,
    method: 'put'
  })
} 

export function getApprovalNum() {
  return request({
    url: `/move/getApprovalNum`,
    method: 'get',
  })
}


export function getStaUser(data) {
  return request({
    url: '/user/getStaUser',
    method: 'post',
    data
  })
}
